const AIIntegrations = ({ apiClient }) => ({
  generateDescription(payload) {
    return apiClient.post('integrations/ai/generate-description', payload, false, {})
  },
  batchGenerateDescriptions(payload) {
    return apiClient.post('integrations/ai/batch-generate', payload, false, {})
  },
  batchList() {
    return apiClient.get('integrations/ai/batch-list')
  },
})

export default AIIntegrations
